<div class="category global-transition" [ngClass]="{'active': activeItem === item?.name, 'd-none': item?.name === 'guides'}" (click)="clickedItem()">
  <div class="category-text">{{ 'view_translations.' + item?.name | translate }}</div>
  <nb-icon *ngIf="item?.name === 'guides'" class="external-link" pack="icomoon" icon="external-link-bold"></nb-icon>
  <div
    class="category-counter"
    *ngIf="!supportPanel && item?.results && item?.name !== 'archival'"
    [ngClass]="{'active-counter': (item?.results?.length ?? 0) > 0,
    'conversationsCounter' : conversationsPanel,
    'd-none': conversationsPanel && ((privateChat.unreadMessages$ | async) === null || (privateChat.unreadMessages$ | async) === 0) }">
    <ng-container *ngIf="!conversationsPanel; else conversationsCounter">
      <span class="length"> {{ item?.results?.length }}</span>
    </ng-container>
    <ng-template #conversationsCounter>
      <span class="length">{{ privateChat.unreadMessages$ | async }}</span>
    </ng-template>
  </div>
</div>
